import { useEffect, useState } from 'react'
import * as customersApi from '@/api/customers'

/** Generic company mark when no logo is uploaded. */
export function GenericCompanyMark({ className = 'h-10 w-10' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <rect width="40" height="40" rx="8" className="fill-slate-200" />
      <path
        d="M10 28V16.5L20 11l10 5.5V28"
        className="stroke-slate-500"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path
        d="M15 28v-6h4v6M21 28v-9h4v9"
        className="stroke-slate-500"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path
        d="M10 28h20"
        className="stroke-slate-500"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  )
}

/**
 * Authenticated customer logo (blob fetch) or generic company mark.
 * Pass logoFilename / updatedAt so the image refreshes after upload.
 */
export function CustomerLogo({
  customerId,
  logoFilename,
  updatedAt,
  className = 'h-12 w-12',
  imgClassName = 'h-full w-full object-contain',
}) {
  const [src, setSrc] = useState(null)

  useEffect(() => {
    if (!customerId || !logoFilename) {
      setSrc(null)
      return undefined
    }
    let cancelled = false
    let objectUrl = null
    async function load() {
      try {
        const blob = await customersApi.fetchCustomerLogoBlob(customerId)
        if (cancelled) return
        objectUrl = URL.createObjectURL(blob)
        setSrc(objectUrl)
      } catch {
        if (!cancelled) setSrc(null)
      }
    }
    load()
    return () => {
      cancelled = true
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [customerId, logoFilename, updatedAt])

  if (!src) {
    return (
      <span
        className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-lg bg-slate-100 ${className}`}
      >
        <GenericCompanyMark className="h-[70%] w-[70%]" />
      </span>
    )
  }

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-lg border border-slate-200 bg-white ${className}`}
    >
      <img src={src} alt="" className={imgClassName} />
    </span>
  )
}
